module.exports = require("live/context/dashboard-widget");